export default __webpack_public_path__ + "static/media/1508.992990eb.png";